import { render, staticRenderFns } from "./aLteInfoBox.vue?vue&type=template&id=b8cb52e4"
import script from "./aLteInfoBox.vue?vue&type=script&lang=js"
export * from "./aLteInfoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b8cb52e4', component.options)
    } else {
      api.reload('b8cb52e4', component.options)
    }
    module.hot.accept("./aLteInfoBox.vue?vue&type=template&id=b8cb52e4", function () {
      api.rerender('b8cb52e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/info-box/aLteInfoBox.vue"
export default component.exports